import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
}
export function CtaButton({
  children,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-6 py-4 text-[15px] sm:px-8 sm:py-5 sm:text-base' : 'px-5 py-3 text-sm';
  return <a href="#comprar" className={`group inline-flex w-full items-center justify-center gap-2.5 rounded-2xl bg-champagne text-center font-semibold uppercase leading-tight tracking-[0.06em] text-ink transition-[transform,background-color] duration-150 ease-soft active:scale-[0.99] hover:bg-champagne-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-champagne sm:w-auto ${sizeClasses} ${className}`} data-id="element-23" data-mp="cn5elgyssp3x">
      <span data-id="element-24" data-mp="19buvp52lpdou">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-4 w-4 shrink-0 transition-transform duration-150 ease-soft group-hover:translate-x-1 sm:h-5 sm:w-5" data-id="element-25" data-mp="198yxdfmucmzv" />
    </a>;
}